import { configureStore } from '@reduxjs/toolkit'
import authReducer from './reducers/authReducer'
import snackbarsReducer from './reducers/snackbarsReducer'
import invoiceMasterReducer from './reducers/invoiceMasterReducer'
import optionRducer from './reducers/optionReducer'

export const store = configureStore({
    reducer: {
        // Define a top-level state field named `todos`, handled by `todosReducer`
        snackbars: snackbarsReducer,
        auth: authReducer,
        invoiceMaster: invoiceMasterReducer,
        options: optionRducer
    }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch